import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TippyDirective } from '@ngneat/helipopper';

@Component({
  selector: 'app-widget-data',
  templateUrl: './data.component.html',
  imports: [
    CommonModule,
    FormsModule,
    TippyDirective,
  ]
})
export class WidgetDataComponent {

  /**
   * Data key
   */
  key = input('');

  /**
   * Data value
   */
  value = input('');

  /**
   * Data tooltip
   */
  tooltip = input('');
}
